import React from "react";
import { Facebook, Instagram, Linkedin, Youtube, X } from "lucide-react";
import fb from "../../assets/image/fb.png";
import xicon from "../../assets/image/x-icon.png";
import linkedin from "../../assets/image/in.png";
import instagram from "../../assets/image/insta.png";
import youtube from "../../assets/image/ytb.png";
import googleplay from "../../assets/image/google-play.png";
import appstore from "../../assets/image/app-stor.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-5">
          <div className="col">
            <div className="footer-column">
              <h4 className="footer-heading">Patients</h4>
              <ul className="footer-list">
                <li>
                  <a href="https://www.pathkindlabs.com/book-a-test/gurugram" target="_blank">
                    {" "}
                    Book a Test
                  </a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/upload-prescription" target="_blank">
                    {" "}
                    Upload Prescription{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="http://104.211.117.133/download_2023/PatientLogin.aspx" target="_blank">
                    {" "}
                    Download Report{" "}
                  </a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/health-packages" target="_blank">
                    Health Packages
                  </a>
                </li>
                <li>
                  <a href="https://nearby.pathkindlabs.com/" target="_blank">Lab Locator</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col">
            <div className="footer-column">
              <h4 className="footer-heading">Partner with us</h4>
              <ul className="footer-list">
                <li>
                  <a href="https://www.pathkindlabs.com/franchise-business-opportunities" target="_blank">
                    Franchise Opportunities
                  </a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/annual-corporate-wellness-program" target="_blank">
                    Corporate Wellness
                  </a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/hospital-lab-management" target="_blank">
                    Hospital Lab Management
                  </a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/organise-free-health-check-up-camps" target="_blank">
                    Organise Camps
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col">
            <div className="footer-column">
              <h4 className="footer-heading">Doctors</h4>
              <ul className="footer-list">
                <li>
                  <a href="https://www.pathkindlabs.com/national-reference-laboratory" target="_blank">
                    National Reference Lab
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://www.pathkindlabs.com/general-clinic-research-and-development" target="_blank">
                    Research and Development
                  </a>
                </li>{" "}
                <li>Research and Development</li>
                <li>
                  <a href="https://www.pathkindlabs.com/download-test-forms" target="_blank">
                    Download Forms
                  </a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/scientific-literature" target="_blank">
                    Scientific Literature
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col">
            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                <li>
                  <a href="https://www.pathkindlabs.com/about-us" target="_blank">About Us</a>
                </li>
                <li>
                  <a href="https://www.pathkindlabs.com/about-us#missionvision" target="_blank">
                    Mission &amp; Vision
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pathkindlabs.com/about-us#management"
                    className=""
                    title="Management"
                    target="_blank"
                  >
                    Board of Directors
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pathkindlabs.com/about-us#managementsTechnical"
                    className=""
                    title="managementsTechnical"
                    target="_blank"
                  >
                    Management
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pathkindlabs.com/careers"
                    className=""
                    title="Career"
                    target="_blank"
                  >
                    Career
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pathkindlabs.com/newsletter"
                    className=""
                    title="Career"
                    target="_blank"
                  >
                    Newsletter
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pathkindlabs.com/press-release"
                    className=""
                    title="PR Media "
                    target="_blank"
                  >
                    PR Media{" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.pathkindlabs.com/disclosures"
                    className=""
                    title="PR Media "
                    target="_blank"
                  >
                    Disclosures{" "}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col">
            <div className="footer-column">
              <h4 className="footer-heading">Contact Us</h4>
              <ul className="footer-list">
               <li><a href="https://www.pathkindlabs.com/contact-us" target="_blank">Get in touch</a></li>
                <li><a href="https://www.pathkindlabs.com/covid-19-faq" target="_blank">Faq</a></li>
                <li><a href="https://www.pathkindlabs.com/sitemaps" target="_blank">Sitemap</a></li>
              </ul>
              <h4 className="footer-heading">Download App</h4>
              <div className="app-download">
                <a
                  href="https://apps.apple.com/in/app/pathkind-labs/id6472930066"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appstore} alt="App Store" className="app-img" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.pathkind.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={googleplay} alt="Play Store" className="app-img" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="qr-code">
          <div className="qr-container">
            <p className="qr-text">Download Our App</p>
            <img src="/qr-code.png" alt="QR Code" className="qr-img" />
          </div>
        </div> */}
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div className="col-md-12 col-lg-12">
            <div className="row">
              <div className="col-12 col-md-9">
                <div className="footer-bottom-left">
                  <strong>Get in Touch</strong> <br />
                  <a
                    href="https://www.pathkindlabs.com/terms-use"
                    className=""
                    title="Terms of Use"
                    target="_blank"
                  >
                    Terms of Use
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/disclaimer"
                    className=""
                    title="Disclaimer"
                    target="_blank"
                  >
                    Disclaimer
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/privacy-policy"
                    className=""
                    title="Privacy Policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/blog"
                    className=""
                    title="Blogs"
                    target="_blank"
                  >
                    Blogs
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.pathkindlabs.com/covid-19-video"
                    className=""
                    title="video"
                    target="_blank"
                  >
                    Video
                  </a>{" "}
                  |{" "}
                  <a
                    className="new-tab"
                    href="https://edos.pathkindlabs.com/"
                    rel="nofollow"
                    title="EDOS"
                    target="_blank"
                    
                  >
                    EDOS
                  </a>{" "}
                  <br />
                  Call Us: <a href="tel:7500075111">75000 75111</a> | Mail Us:
                  <a href="mailto:care@pathkindlabs.com">
                    care@pathkindlabs.com
                  </a>{" "}
                  |{" "}
                  <a href="https://www.pathkindlabs.com/radiology">
                    Radiology Test Available only in Varanasi, Kolkata &amp;
                    Gurgaon
                  </a>{" "}
                  <br />© 2025 Pathkind Diagnostics Pvt. Ltd. All Rights
                  Reserved | Unsubscribe
                </div>
              </div>
              <div className="col-12 col-md-3">
                <div className="footer-social">
                  <div className="footer-follow">Follow us</div>
                  <a
                    href="https://www.facebook.com/PathkindLabs/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={fb} alt="Facebook" className="social-icon pr-3" />
                  </a>
                  <a
                    href="https://twitter.com/pathkindlabs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={xicon} alt="X" className="social-icon pr-3" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/pathkind-diagnostics-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={linkedin}
                      alt="LinkedIn"
                      className="social-icon pr-3"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/pathkind/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={instagram}
                      alt="Instagram"
                      className="social-icon pr-3"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/@pathkind-labs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={youtube} alt="YouTube" className="social-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
